import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/public/app/tour/[...slug]/tour-page-client.tsx");
